'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroTable = require('./NitroTable');

var _NitroTable2 = _interopRequireDefault(_NitroTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroTable2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-table/index.js
// module id = 766
// module chunks = 4